import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <div className="logo">
            <i className="fas fa-bolt"></i>
            <span>Orient Engineers</span>
          </div>
            </div>
            <p>Leading provider of hospital and laboratory equipment in Nigeria. We deliver cutting-edge medical solutions for better healthcare outcomes.</p>
            <div className="social-links">
              <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
              <a href="#" aria-label="WhatsApp"><i className="fab fa-whatsapp"></i></a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#services">Equipment</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Equipment</h4>
            <ul>
              <li><a href="#services">Diagnostic Imaging</a></li>
              <li><a href="#services">Laboratory Equipment</a></li>
              <li><a href="#services">Surgical Instruments</a></li>
              <li><a href="#services">Patient Monitoring</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <span>NO 49/50 Kachia Road, Sabo Tasha Kaduna</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone"></i>
              <span>+234 (0) 901 234 5678</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <span>info@jarvissurgical.com</span>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 Jarvis Surgical. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;